var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"series-wrapper d-flex justify-center"},[_c('div',{staticClass:"series-thumbnail"},[_vm._t("dicomImage"),_c('div',{staticClass:"series-details d-flex justify-space-between align-center"},[_c('span',{staticClass:"title"},[_vm._t("title")],2),_c('span',{staticClass:"icon"},[_vm._t("number-and-icon")],2)])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }